import React from "react"
import {AlertDialog, Button, Flex} from '@radix-ui/themes'

export interface BaseModalProps extends AlertDialog.RootProps {
    showButton: React.JSX.Element,
    title: string,
    description: string | React.JSX.Element,
    cancelButton: React.JSX.Element,
    successButton: React.JSX.Element,
    classNameDialogContent?: string,
    maxWidth?: string,
    maxHeight?: string
}


export default function BaseModal(props: BaseModalProps) {
    const {showButton, title, description, cancelButton, successButton, classNameDialogContent, maxHeight, maxWidth, ...other} = props
    return (
        <AlertDialog.Root {...other}>
        <AlertDialog.Trigger>
            {showButton}
        </AlertDialog.Trigger>
        <AlertDialog.Content maxWidth={maxWidth || '450px'} className={`${classNameDialogContent}`}>
            <AlertDialog.Title>{title}</AlertDialog.Title>
               {description}
            <Flex gap="3" mt="4" justify="end">
                <AlertDialog.Cancel>
                   {cancelButton}
                </AlertDialog.Cancel>
                <AlertDialog.Action>
                   {successButton}
                </AlertDialog.Action>
            </Flex>
        </AlertDialog.Content>
    </AlertDialog.Root>
    )
}